import React from 'react'

import './index.css'

function StopAccess() {
    return (
        <div className="stop-access-page">
            <div className="stop-access-panel">
                <div className="stop-access-icon">!</div>
                <h1>停止访问</h1>
                <p>当前页面已停止访问</p>
            </div>
        </div>
    )
}

export default StopAccess
